var STRING = 'STRING';
var NUMBER = 'NUMBER';
var MONEY_INPUT = 'MONEY_INPUT';
var HOUR_INPUT = 'HOUR_INPUT';
var SINGLE_SELECT = 'SINGLE_SELECT';
var MULTI_SELECT = 'MULTI_SELECT';
var DATE = 'DATE';
var ASYNC_SINGLE_SELECT = 'ASYNC_SINGLE_SELECT';
var ASYNC_MULTI_SELECT = 'ASYNC_MULTI_SELECT';
var DATE_WITHOUT_PRESET = 'DATE_WITHOUT_PRESET';
var DATE_TIME_WITHOUT_PRESET = 'DATE_TIME_WITHOUT_PRESET';
var DATE_PICKER = 'DATE_PICKER';
var MONTH_PICKER = 'MONTH_PICKER';
var VIRTUALIZED_MULTI_SELECT = 'VIRTUALIZED_MULTI_SELECT';
var VIRTUALIZED_SELECT = 'VIRTUALIZED_SELECT';
var AMOUNT_DOLLAR_RANGE = 'AMOUNT_DOLLAR_RANGE';
var NUMBER_INPUT_RANGE = 'NUMBER_INPUT_RANGE';
var NUMBER_INPUT_WITH_RANGE = 'NUMBER_INPUT_WITH_RANGE'; // when operator is BTW then filter would have a range input else plain number iput
var CUSTOM = 'CUSTOM';
var SCRIPT = 'SCRIPT';
var FILTER_TYPES = {
  STRING: STRING,
  NUMBER: NUMBER,
  MONEY_INPUT: MONEY_INPUT,
  HOUR_INPUT: HOUR_INPUT,
  SINGLE_SELECT: SINGLE_SELECT,
  MULTI_SELECT: MULTI_SELECT,
  DATE: DATE,
  ASYNC_SINGLE_SELECT: ASYNC_SINGLE_SELECT,
  DATE_WITHOUT_PRESET: DATE_WITHOUT_PRESET,
  DATE_TIME_WITHOUT_PRESET: DATE_TIME_WITHOUT_PRESET,
  DATE_PICKER: DATE_PICKER,
  MONTH_PICKER: MONTH_PICKER,
  VIRTUALIZED_MULTI_SELECT: VIRTUALIZED_MULTI_SELECT,
  ASYNC_MULTI_SELECT: ASYNC_MULTI_SELECT,
  VIRTUALIZED_SELECT: VIRTUALIZED_SELECT,
  AMOUNT_DOLLAR_RANGE: AMOUNT_DOLLAR_RANGE,
  NUMBER_INPUT_RANGE: NUMBER_INPUT_RANGE,
  NUMBER_INPUT_WITH_RANGE: NUMBER_INPUT_WITH_RANGE,
  CUSTOM: CUSTOM,
  SCRIPT: SCRIPT
};
export default FILTER_TYPES;